export default () => {
  const sections = document.querySelectorAll('.shopify-section');

  sections.forEach((section) => {
    if (window.getComputedStyle(section).display === 'none') {
      section.remove();
    }
  });
};
